import { Component, OnInit } from '@angular/core';

import { ToastService } from './toast.service';

@Component({
    selector: 'flo-toast-msg',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
    private static get MSG_TYPE_SUCCESS(): string {
        return 'success';
    }

    private static get MSG_TYPE_WARNING(): string {
        return 'warning';
    }

    private static get MSG_TYPE_ERROR(): string {
        return 'error';
    }

    public title: string;
    public message: string;
    public messageType: string;
    public showToast: boolean;
    public hideToast: boolean;
    private hideTimeout: number;

    private _defaults: any = {
        title: '',
        message: '',
        successDisplayTime: 2500,
        warningDisplayTime: 2500,
        errorDisplayTime: -1, // -1 == no auto hide
    };

    get isSuccess(): boolean {
        return this.messageType === ToastComponent.MSG_TYPE_SUCCESS;
    }

    get isWarning(): boolean {
        return this.messageType === ToastComponent.MSG_TYPE_WARNING;
    }

    get isError(): boolean {
        return this.messageType === ToastComponent.MSG_TYPE_ERROR;
    }

    private _toastElement: any;

    constructor(toastService: ToastService) {
        toastService.showSuccess = this.showSuccess.bind(this);
        toastService.showWarning = this.showWarning.bind(this);
        toastService.showError = this.showError.bind(this);
        toastService.clear = this._clear.bind(this);
    }

    public showSuccess(
        message: string = this._defaults.message,
        title: string = this._defaults.title,
        displayTime: number = this._defaults.successDisplayTime,
    ): void {
        this._show(title, message, displayTime, ToastComponent.MSG_TYPE_SUCCESS);
    }

    public showWarning(
        message: string = this._defaults.message,
        title: string = this._defaults.title,
        displayTime: number = this._defaults.warningDisplayTime,
    ): void {
        this._show(title, message, displayTime, ToastComponent.MSG_TYPE_WARNING);
    }

    public showError(
        message: string = this._defaults.message,
        title: string = this._defaults.title,
        displayTime: number = this._defaults.errorDisplayTime,
    ): void {
        this._show(title, message, displayTime, ToastComponent.MSG_TYPE_ERROR);
    }

    public ngOnInit(): void {
        this._toastElement = document.getElementById('toast');
    }

    public onClickClose(): void {
        this._hide();
    }

    private _show(message: string, title: string, displayTime: number, messageType: string): void {
        this.message = message;
        this.title = title;
        this.messageType = messageType;
        this.hideToast = false;
        this.showToast = true;

        // If a timeout exists it needs to be cleared so it doesn't hide before this new message's displayTime expires
        if (this.hideTimeout) {
            window.clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }

        if (displayTime !== -1) {
            this.hideTimeout = window.setTimeout(() => this._hide(), displayTime);
        }
    }

    private _hide(): void {
        this.hideToast = true;
        window.setTimeout(() => { this._toastElement.style.zIndex = 0; }, 400);
    }

    private _clear(): void {
        this._hide();
    }
}
